var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFallback = function SvgFallback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M46.61.03H17.4C7.83.03.04 7.82.04 17.39V46.6c0 9.57 7.79 17.36 17.36 17.36h29.21c9.57 0 17.36-7.79 17.36-17.36V17.39C63.97 7.82 56.18.03 46.61.03m15.36 46.58c0 8.22-7.245 14.93-15.365 15.32-3.136 0-19.226.03-29.216.03-8.47 0-15.36-6.89-15.36-15.36V17.39c0-8.47 6.89-15.36 15.36-15.36H46.6c8.47 0 15.36 6.89 15.36 15.36V46.6Z"
  })));
};
export default SvgFallback;